// BookingApprove.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import { createMRTColumnHelper } from "material-react-table";
import MasterLayout from "../../masterLayout/MasterLayout.jsx";
import { baseUrl } from "../../helper/urls.js";
import CustomTable from "../../components/custom_table/CustomTable.jsx";
import { Button, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import { useSelector } from "react-redux";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  height: 600,
  maxHeight: "80vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const StudentRequestedSlotList = ({ status }) => {
  const { token } = useSelector((state) => state.auth);
  const [counselors, setCounselors] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openModal3, setOpenModal3] = React.useState(false);
  const [modalData, setModalData] = useState(null);
  const handleOpen3 = (dataToPass) => {
    setModalData(dataToPass); // Store the data
    setOpenModal3(true); // Open the modal
  };
  const paymentLink = (dataToPass) => {
    window.open(dataToPass.modalData.row.payment_link, "_blank");
    setModalData(null); // Store the data
    setOpenModal3(false); // Open the modal
  };
  const handleClose3 = () => {
    setOpenModal3(false);
    setModalData(null); // Clear data when closing
  };
  const fetchCounselors = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/booking_req/byStudent`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const AllData = response.data.data || [];

      // Add formattedReqId here
      const processedData = AllData.map((item) => ({
        ...item,

        formattedReqId: `DDR000${item.id || ""}`,

        counselorName: `${item.counselorFirstName || ""} ${
          item.counselorLastName || ""
        }`.trim(),

        serviceType: item.counselorinterestedIn || "",

        approvedSlots: item.approved_slots ?? 0,

        unscheduledSlots: item.Unscheduled ?? 0,

        amountDue: item.total_amount ?? "-",

        statusLabel:
          item.status === 0
            ? "Pending"
            : item.status === 1
            ? "Unpaid"
            : item.status === 2
            ? "Paid"
            : item.status === 3
            ? "Completed"
            : item.status === 4
            ? "Cancelled"
            : "Unknown",
      }));

      setCounselors(processedData);
      setLoading(false);
    } catch (error) {
      setError("error bookingwihtaaaaaaaaaaaa", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCounselors();
  }, []);

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("payment_link", {
      header: "Action",
      size: 20,
      Cell: (cell) => {
        const row = cell.row.original;
        const { status, approved_slots, Scheduled } = row;

        if (approved_slots === Scheduled) {
          return (
            <Button variant="contained" size="small" disabled>
              All Slots are Scheduled
              {/* All Slots Booked */}
            </Button>
          );
        }

        // if (status === 1 && payment_link) {
        if (status === 1) {
          return (
            <Button
              variant="contained"
              size="small"
              sx={{ backgroundColor: "#124178", color: "white" }}
              onClick={() => handleOpen3({ row })}
            >
              Pay Now
            </Button>
          );
        }

        if (status === 2) {
          return (
            <Button
              variant="contained"
              size="small"
              color="success"
              onClick={() => {
                navigate("/student-slot-booking", {
                  state: {
                    counselorId: row.counselorId,
                    studentId: row.studentId,
                    reqId: row.id,
                    UnscheduledSlot: row.Unscheduled,
                  },
                });
              }}
            >
              Book Slot
            </Button>
          );
        }

        return null;
      },
    }),
    columnHelper.accessor("statusLabel", {
      header: "Status",
      size: 20,
      Cell: ({ cell }) => {
        const status = cell.getValue();

        let color = "default";
        switch (status) {
          case "Pending":
            color = "warning";
            break;
          case "Unpaid":
            color = "error";
            break;
          case "Paid":
            color = "success";
            break;
          case "Completed":
            color = "primary";
            break;
          case "Cancelled":
            color = "primary";
            break;
          default:
            color = "default";
        }

        return <Chip label={status} color={color} variant="contained" />;
      },
    }),

    columnHelper.accessor("counselorName", {
      header: "Counselor Name",
      size: 40,
    }),
    columnHelper.accessor("serviceType", {
      header: "Service Type",
      size: 40,
    }),

    columnHelper.accessor("approvedSlots", {
      header: "Total Slots",
      size: 20,
    }),
    columnHelper.accessor("Unscheduled", {
      header: "Remaining Slots",
      size: 20,
      Cell: ({ cell }) => {
        const unscheduled = cell.getValue() ?? 0;
        return <Chip label={unscheduled} color="warning" />;
      },
    }),
    columnHelper.accessor("amountDue", {
      header: "Amount Due($)",
      size: 30,
    }),

    columnHelper.accessor("formattedReqId", {
      header: "Request ID",
      size: 20,
    }),
  ];

  return (
    <MasterLayout>
      <CustomTable columns={columns} data={counselors} loading={loading} />
      {modalData && (
        <Modal
          open={openModal3}
          onClose={handleClose3}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <IconButton
              onClick={handleClose3}
              sx={{ position: "absolute", top: 8, right: 8 }}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>

            <div className="card-body">
              <div className="row justify-content-center" id="invoice">
                <div className="col-lg-12">
                  <div className="shadow-4 border radius-8">
                    <div className="p-20 border-bottom">
                      <div className="row justify-content-between g-3">
                        <div className="col-sm-12 align-items-">
                          <img
                            src="assets/images/logo.png"
                            alt="image_icon"
                            className="mb-8 d-block mx-auto"
                            style={{ width: "150px" }}
                          />
                          <p className="mb-1 text-sm text-center">
                            {" "}
                            46th AVE SE Snohmish, WA 98296
                          </p>
                          <p className="mb-0 text-sm text-center">
                            support@dreamdor.com | +1(425) 298-3671
                          </p>{" "}
                          {/* Added text-center here for text */}
                        </div>
                      </div>
                      <div className="row justify-content-between g-3">
                        <div className="col-sm-12  align-items-">
                          <h3 className="text-xl text-center">
                            PAYMENT SUMMARY
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="py-28 px-20">
                      <div className="d-flex flex-wrap justify-content-between align-items-end gap-3">
                        <div>
                          <h6 className="text-md">Issued For:</h6>
                          <table className="text-sm text-secondary-light">
                            <tbody>
                              <tr>
                                <td>Name</td>
                                <td className="ps-8">
                                  :{" "}
                                  <span className="">
                                    {modalData.row.studentFirstName}{" "}
                                    {modalData.row.studentLastName}
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div>
                          <table className="text-sm text-secondary-light">
                            <tbody>
                              <tr>
                                <td>Request ID</td>
                                <td className="ps-8">
                                  : DDR000{modalData.row.id}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="mt-24">
                        <div className="table-responsive scroll-sm">
                          <table
                            className="table bordered-table text-sm"
                            id="invoice-table"
                          >
                            <thead>
                              <tr>
                                <th scope="col" className="text-sm">
                                  SL.
                                </th>
                                <th scope="col" className="text-sm">
                                  Item
                                </th>
                                <th scope="col" className="text-sm">
                                  Qty
                                </th>
                                <th scope="col" className="text-sm">
                                  Units
                                </th>
                                <th scope="col" className="text-sm">
                                  Per Hour Price
                                </th>
                                <th scope="col" className="text-sm">
                                  Price
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>01</td>
                                <td>{modalData.row.counselorinterestedIn}</td>
                                <td>{modalData.row.approved_slots}</td>
                                <td>Slots</td>

                                <td>
                                  $
                                  {Number(
                                    modalData.row.counselorPricePerHour
                                  ).toFixed(2)}
                                </td>

                                <td>${modalData.row.amountBeforeDiscount}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div className="d-flex flex-wrap justify-content-between gap-3 mt-24">
                          <div>
                            <p className="text-sm mb-0"></p>
                            <p className="text-sm mb-0"></p>
                          </div>
                          <div>
                            <table className="text-sm">
                              <tbody>
                                <tr>
                                  <td className="pe-64">Subtotal:</td>
                                  <td className="pe-16">
                                    <span className="text-primary-light fw-semibold">
                                      ${modalData.row.amountBeforeDiscount}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td className="pe-64">Discount:</td>
                                  <td className="pe-16">
                                    <span className="text-primary-light fw-semibold">
                                      ${modalData.row.discount_amount}
                                    </span>
                                  </td>
                                </tr>

                                <tr>
                                  <td className="pe-64 pt-4">
                                    <span className="text-primary-light fw-semibold">
                                      Total:
                                    </span>
                                  </td>
                                  <td className="pe-16 pt-4">
                                    <span className="text-primary-light fw-semibold">
                                      ${modalData.row.total_amount}
                                    </span>
                                  </td>
                                </tr>
                                <tr>
                                  <td colSpan={"2"}>
                                    <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-success-600 radius-8 d-inline-flex align-items-center gap-1"
                                        onClick={() =>
                                          paymentLink({ modalData })
                                        }
                                      >
                                        Pay Now
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Modal>
      )}
    </MasterLayout>
  );
};

export default StudentRequestedSlotList;

// // BookingApprove.jsx
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { createMRTColumnHelper } from "material-react-table";
// // import CustomTable from "../../components/custom_table/CustomTable.jsx";
// // import { baseUrl } from "../../helper/urls.js";
// import MasterLayout from "../../masterLayout/MasterLayout.jsx";
// import { baseUrl } from "../../helper/urls.js";
// import CustomTable from "../../components/custom_table/CustomTable.jsx";
// import { Button, Chip } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import CloseIcon from "@mui/icons-material/Close";
// import { Icon } from "@iconify/react/dist/iconify.js";
// import {
//   Card,
//   CardContent,
//   Typography,
//   Box,
//   Avatar,
//   IconButton,
// } from "@mui/material";
// import Modal from "@mui/material/Modal";
// import { useSelector } from "react-redux";
// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: 800,
//   height: 600,
//   maxHeight: "80vh",
//   overflowY: "auto",
//   bgcolor: "background.paper",
//   border: "2px solid #000",
//   boxShadow: 24,
//   p: 4,
// };
// const StudentRequestedSlotList = ({ status }) => {
//   const { token } = useSelector((state) => state.auth);
//   const [counselors, setCounselors] = useState([]);
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [openModal3, setOpenModal3] = React.useState(false);
//   const [modalData, setModalData] = useState(null);

//   // const handleClose3 = () => setOpenModal3(false);
//   // const handleOpen3 = () => setOpenModal3(true);
//   const handleOpen3 = (dataToPass) => {
//     setModalData(dataToPass); // Store the data
//     setOpenModal3(true); // Open the modal
//   };
//   const paymentLink = (dataToPass) => {
//     window.open(dataToPass.modalData.row.payment_link, "_blank");
//     setModalData(null); // Store the data
//     setOpenModal3(false); // Open the modal
//   };
//   const handleClose3 = () => {
//     setOpenModal3(false);
//     setModalData(null); // Clear data when closing
//   };
//   const fetchCounselors = async () => {
//     try {
//       // console.log("akkkkkkkkkkkkkkkkkkk", counselor);
//       const response = await axios.get(`${baseUrl}/api/booking_req/byStudent`, {
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setCounselors(response.data.data);
//       setLoading(false);
//     } catch (error) {
//       setError("error bookingwihtaaaaaaaaaaaa", error);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchCounselors();
//   }, []);

//   const columnHelper = createMRTColumnHelper();
//   const columns = [
//     columnHelper.accessor("payment_link", {
//       header: "Action",
//       size: 20,
//       Cell: (cell) => {
//         const row = cell.row.original;
//         const {
//           payment_link,
//           status,
//           approved_slots,
//           Scheduled,
//           discount_amount,
//           total_amount,
//           amountBeforeDiscount,
//           counselorPricePerHour,
//           counselorinterestedIn,
//         } = row;

//         if (approved_slots === Scheduled) {
//           return (
//             <Button variant="contained" size="small" disabled>
//               All Slots are Scheduled
//               {/* All Slots Booked */}
//             </Button>
//           );
//         }

//         // if (status === 1 && payment_link) {
//         if (status === 1) {
//           return (
//             <Button
//               variant="contained"
//               size="small"
//               sx={{ backgroundColor: "#124178", color: "white" }}
//               onClick={() => handleOpen3({ row })}
//               // onClick={() => window.open(payment_link, "_blank")}
//             >
//               Pay Now
//             </Button>
//           );
//         }

//         if (status === 2) {
//           return (
//             <Button
//               variant="contained"
//               size="small"
//               color="success"
//               // sx={{ backgroundColor: "#28a745", color: "white" }}
//               onClick={() => {
//                 navigate("/student-slot-booking", {
//                   state: {
//                     counselorId: row.counselorId,
//                     studentId: row.studentId,
//                     reqId: row.id,
//                     UnscheduledSlot: row.Unscheduled,
//                   },
//                   // state: { row },
//                 });
//               }}
//             >
//               Book Slot
//             </Button>
//           );
//         }

//         return null;
//       },
//     }),
//     // columnHelper.accessor("id", { header: "Request ID", size: 20 }),

//     // columnHelper.accessor("studentFirstName", {
//     //   header: "Student Name",
//     //   size: 40,
//     //   Cell: (cell) => {
//     //     const { studentFirstName, studentLastName } = cell.row.original || {};
//     //     console.log("studentFirstName", studentFirstName, studentLastName);
//     //     return (
//     //       <div>{(studentFirstName || "") + " " + (studentLastName || "")}</div>
//     //     );
//     //   },
//     // }),
//     columnHelper.accessor("status", {
//       header: "Status",
//       size: 20,
//       Cell: (cell) => {
//         const status = cell.row.original?.status;
//         if (status === 0)
//           return (
//             <Chip
//               label="Pending"
//               variant="contained"
//               color="warning"
//               // sx={{
//               //   backgroundColor: "yellow",
//               //   color: "black", // Ensure text is readable
//               // }}
//             />
//           );
//         // return <Chip label="Pending" color="yellow" variant="contained" />;
//         if (status === 1)
//           return <Chip label="Unpaid" color="error" variant="contained" />;

//         if (status === 2)
//           return <Chip label=" Paid " color="success" variant="contained" />;
//         if (status === 3)
//           return <Chip label="Completed" color="primary" variant="contained" />;
//         if (status === 4)
//           return <Chip label="Cancelled" color="primary" variant="contained" />;
//         return "Unknown";
//       },
//     }),
//     columnHelper.accessor("counselorFirstName", {
//       header: "Counselor Name",
//       size: 40,
//       Cell: (cell) =>
//         cell.row.original?.counselorFirstName +
//         " " +
//         cell.row.original?.counselorLastName,
//     }),
//     columnHelper.accessor("counselorinterestedIn", {
//       header: "Service Type",
//       size: 40,
//       Cell: (cell) => cell.row.original?.counselorinterestedIn,
//     }),

//     // columnHelper.accessor("call_time", {
//     //   header: "Call Time",
//     //   size: 30,
//     //   Cell: (cell) => cell.row.original?.call_time || "N/A",
//     // }),

//     columnHelper.accessor("approved_slots", {
//       header: "Total Slots",
//       size: 20,
//       Cell: (cell) => cell.row.original?.approved_slots || 0,
//     }),
//     // columnHelper.accessor("Scheduled", {
//     //   header: "Scheduled Slots",
//     //   size: 20,
//     //   Cell: (cell) => cell.row.original?.Scheduled,
//     // }),
//     columnHelper.accessor("Unscheduled", {
//       header: "Unscheduled Slots",
//       size: 20,
//       Cell: (cell) => {
//         const Unscheduled = cell.row.original?.Unscheduled || 0;
//         return (
//           <div>
//             <Chip label={Unscheduled} color="warning" />
//           </div>
//         );
//       },
//     }),
//     columnHelper.accessor("total_amount", {
//       header: "Amount Due($)",
//       size: 30,
//       Cell: (cell) => cell.row.original?.total_amount || "-",
//     }),

//     columnHelper.accessor("id", {
//       header: "Request ID",
//       size: 20,
//       Cell: (cell) => "DDR000" + cell.row.original?.id,
//     }),

//     // columnHelper.accessor("payment_link", {
//     //   header: "Action",
//     //   size: 20,
//     //   Cell: (cell) => {
//     //     const link = cell.row.original?.payment_link;
//     //     const status = cell.row.original?.status;
//     //     return link && status === 1 ? (
//     //       <Button
//     //         variant="contained"
//     //         size="small"
//     //         sx={{
//     //           backgroundColor: "#124178",
//     //           color: "white",
//     //         }}
//     //         onClick={() => window.open(link, "_blank")}
//     //       >
//     //         Pay
//     //       </Button>
//     //     ) : (
//     //       ""
//     //     );
//     //   },
//     // }),

//     // columnHelper.accessor("created_at", {
//     //   header: "Created At",
//     //   size: 30,
//     //   Cell: (cell) => {
//     //     return (
//     //       <Button
//     //         variant="contained"
//     //         // color="primary"
//     //         size="small"
//     //         sx={{
//     //           // mt: 3,
//     //           // width: "100%",
//     //           backgroundColor: "#124178",
//     //           color: "white",
//     //         }}
//     //         onClick={() => navigate("/student-slot-booking")}
//     //       >
//     //         Book Slot
//     //       </Button>
//     //     );
//     //   },
//     // }),
//   ];

//   return (
//     <MasterLayout>
//       <CustomTable columns={columns} data={counselors} loading={loading} />
//       {modalData && (
//         <Modal
//           open={openModal3}
//           onClose={handleClose3}
//           aria-labelledby="modal-modal-title"
//           aria-describedby="modal-modal-description"
//         >
//           <Box sx={style}>
//             <IconButton
//               onClick={handleClose3}
//               sx={{ position: "absolute", top: 8, right: 8 }}
//               aria-label="close"
//             >
//               <CloseIcon />
//             </IconButton>
//             {/* <div className="card">
//                                    <div className="card-header">
//                                        <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
//                                            <button
//                                                type="button"
//                                                className="btn btn-sm btn-primary-600 radius-8 d-inline-flex align-items-center gap-1"
//                                                onClick={() => window.open(modalData.row.payment_link, "_blank")}
//                                            >

//                                                Pay Now
//                                            </button>
//                                        </div>
//                                    </div>

//                                </div> */}
//             <div className="card-body">
//               <div className="row justify-content-center" id="invoice">
//                 <div className="col-lg-12">
//                   <div className="shadow-4 border radius-8">
//                     <div className="p-20 border-bottom">
//                       <div className="row justify-content-between g-3">
//                         <div className="col-sm-12 align-items-">
//                           <img
//                             src="assets/images/logo.png"
//                             alt="image_icon"
//                             className="mb-8 d-block mx-auto" // Added d-block and mx-auto here
//                             style={{ width: "150px" }}
//                           />
//                           <p className="mb-1 text-sm text-center">
//                             {" "}
//                             {/* Added text-center here for text */}
//                             46th AVE SE Snohmish, WA 98296
//                           </p>
//                           <p className="mb-0 text-sm text-center">
//                             support@dreamdor.com | +1(425) 298-3671
//                           </p>{" "}
//                           {/* Added text-center here for text */}
//                         </div>
//                       </div>
//                       <div className="row justify-content-between g-3">
//                         <div className="col-sm-12  align-items-">
//                           <h3 className="text-xl text-center">
//                             PAYMENT SUMMARY
//                           </h3>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="py-28 px-20">
//                       <div className="d-flex flex-wrap justify-content-between align-items-end gap-3">
//                         <div>
//                           <h6 className="text-md">Issued For:</h6>
//                           <table className="text-sm text-secondary-light">
//                             <tbody>
//                               <tr>
//                                 <td>Name</td>
//                                 <td className="ps-8">
//                                   :{" "}
//                                   <span className="">
//                                     {modalData.row.studentFirstName}{" "}
//                                     {modalData.row.studentLastName}
//                                   </span>
//                                 </td>
//                               </tr>
//                               {/* <tr>
//                                                                            <td>Address</td>
//                                                                            <td className="ps-8">
//                                                                                :{" "}
//                                                                                <span className="editable text-decoration-underline">
//                                                                                    4517 Washington Ave.USA
//                                                                                </span>{" "}
//                                                                                <span className="text-success-main">
//                                                                                    <Icon icon="mage:edit" />
//                                                                                </span>
//                                                                            </td>
//                                                                        </tr>
//                                                                        <tr>
//                                                                            <td>Phone number</td>
//                                                                            <td className="ps-8">
//                                                                                :{" "}
//                                                                                <span className="editable text-decoration-underline">
//                                                                                    +1 543 2198
//                                                                                </span>{" "}
//                                                                                <span className="text-success-main">
//                                                                                    <Icon icon="mage:edit" />
//                                                                                </span>
//                                                                            </td>
//                                                                        </tr> */}
//                             </tbody>
//                           </table>
//                         </div>
//                         <div>
//                           <table className="text-sm text-secondary-light">
//                             <tbody>
//                               <tr>
//                                 <td>Request ID</td>
//                                 <td className="ps-8">
//                                   : DDR000{modalData.row.id}
//                                 </td>
//                               </tr>
//                             </tbody>
//                           </table>
//                         </div>
//                       </div>
//                       <div className="mt-24">
//                         <div className="table-responsive scroll-sm">
//                           <table
//                             className="table bordered-table text-sm"
//                             id="invoice-table"
//                           >
//                             <thead>
//                               <tr>
//                                 <th scope="col" className="text-sm">
//                                   SL.
//                                 </th>
//                                 <th scope="col" className="text-sm">
//                                   Item
//                                 </th>
//                                 <th scope="col" className="text-sm">
//                                   Qty
//                                 </th>
//                                 <th scope="col" className="text-sm">
//                                   Units
//                                 </th>
//                                 <th scope="col" className="text-sm">
//                                   Per Hour Price
//                                 </th>
//                                 <th scope="col" className="text-sm">
//                                   Price
//                                 </th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               <tr>
//                                 <td>01</td>
//                                 <td>{modalData.row.counselorinterestedIn}</td>
//                                 <td>{modalData.row.approved_slots}</td>
//                                 <td>Slots</td>
//                                 {/* <td>${modalData.row.counselorPricePerHour}</td> */}
//                                 <td>
//                                   $
//                                   {Number(
//                                     modalData.row.counselorPricePerHour
//                                   ).toFixed(2)}
//                                 </td>

//                                 <td>${modalData.row.amountBeforeDiscount}</td>
//                               </tr>
//                             </tbody>
//                           </table>
//                         </div>

//                         <div className="d-flex flex-wrap justify-content-between gap-3 mt-24">
//                           <div>
//                             <p className="text-sm mb-0"></p>
//                             <p className="text-sm mb-0"></p>
//                           </div>
//                           <div>
//                             <table className="text-sm">
//                               <tbody>
//                                 <tr>
//                                   <td className="pe-64">Subtotal:</td>
//                                   <td className="pe-16">
//                                     <span className="text-primary-light fw-semibold">
//                                       ${modalData.row.amountBeforeDiscount}
//                                     </span>
//                                   </td>
//                                 </tr>
//                                 <tr>
//                                   <td className="pe-64">Discount:</td>
//                                   <td className="pe-16">
//                                     <span className="text-primary-light fw-semibold">
//                                       ${modalData.row.discount_amount}
//                                     </span>
//                                   </td>
//                                 </tr>
//                                 {/* <tr>
//                                                                                <td className="pe-64 border-bottom pb-4">Tax:</td>
//                                                                                <td className="pe-16 border-bottom pb-4">
//                                                                                    <span className="text-primary-light fw-semibold">
//                                                                                        0.00
//                                                                                    </span>
//                                                                                </td>
//                                                                            </tr> */}
//                                 <tr>
//                                   <td className="pe-64 pt-4">
//                                     <span className="text-primary-light fw-semibold">
//                                       Total:
//                                     </span>
//                                   </td>
//                                   <td className="pe-16 pt-4">
//                                     <span className="text-primary-light fw-semibold">
//                                       ${modalData.row.total_amount}
//                                     </span>
//                                   </td>
//                                 </tr>
//                                 <tr>
//                                   <td colSpan={"2"}>
//                                     <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
//                                       <button
//                                         type="button"
//                                         className="btn btn-sm btn-success-600 radius-8 d-inline-flex align-items-center gap-1"
//                                         onClick={() =>
//                                           paymentLink({ modalData })
//                                         }
//                                       >
//                                         Pay Now
//                                       </button>
//                                     </div>
//                                   </td>
//                                 </tr>
//                               </tbody>
//                             </table>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </Box>
//         </Modal>
//       )}
//     </MasterLayout>
//   );
// };

// export default StudentRequestedSlotList;
